"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
export function ApiReferenceAnchorRedirect({
  operations,
}: {
  operations: { id: string; href: string }[];
}) {
  const router = useRouter();
  useEffect(() => {
    const redirectAnchor = () => {
      const hash = location.hash.toLowerCase();
      if (!hash) return;
      const operation = operations.find(
        (op) =>
          op.href.slice(op.href.indexOf("#")) === hash ||
          `#${op.id.toLowerCase()}` === hash,
      );
      if (
        operation &&
        operation.href !== `${location.pathname}${location.hash}`
      )
        router.replace(operation.href);
    };
    redirectAnchor();
    window.addEventListener("hashchange", redirectAnchor);
    return () => window.removeEventListener("hashchange", redirectAnchor);
  }, [operations, router]);
  return null;
}
